import GoogleAdUnit from '../../components/GoogleAdUnit';
import React, { useEffect, useState } from 'react'
import {  NavLink , Row, Col } from "react-bootstrap"
import { Tooltip } from "@mui/material";
import axios from '../../API/axios';
import { post } from '../../config/imagesLink';
import DraftInteraction from './DraftInteraction';
import { icons, JobSearch } from '../../config/imagesLink';
import JobDraftInteraction from './JobDraftInteraction';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { ShimmerDiv, ImageWithLoader } from "@skeleton";
import PostComponent from '../NewsFeed/PostComponent';
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from 'react-i18next';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import WorkOutlineSharpIcon from '@mui/icons-material/WorkOutlineSharp';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PortalJobCard from '../../components/PortalJobCard';
import '../JobSearch/JobSearchRedesign.css';

const DRAFT_TAB_MAP = {
    postdrafts: 1,
    jobdrafts: 2,
};

const DRAFT_TAB_ROUTES = {
    1: "PostDrafts",
    2: "JobDrafts",
};

const getDraftTabIndex = (routeTab) => {
    const tabKey = (routeTab || "").toLowerCase();
    return DRAFT_TAB_MAP[tabKey] || 1;
};

const Draft = () => {
    const { t } = useTranslation();

    const sessionId = localStorage.getItem("sessionId");
    const location = useLocation();
    const navigate = useNavigate();
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(() => getDraftTabIndex(tab));

    const goToDraftTab = (tabIndex) => {
        setActiveTab(tabIndex);
        const tabPath = DRAFT_TAB_ROUTES[tabIndex];
        if (tabPath) {
            navigate(`/Draft/${tabPath}`);
        }
    };

    //************************ Draft Job Start  ************************//
    const [draftJob, setDraftJob] = useState([]);
    const [isLoadingJob, setIsLoadingJob] = useState(false);
    const language = localStorage.getItem("Lang");
    const localeMap = {
        en: "en",
        ar: "ar",
        hi: "hi",
    };

    const locale = localeMap[language] || "en";
    const [isPostDraftError, setIsPostDraftError] = useState(false);
    console.log('draftJob', draftJob);

    const DraftJob = async () => {
        const Data = {
            "deviceType": "Web",
            "sessionId": sessionId,
            langKey: language === "en" ? "" : language,
        }
        try {
            setIsLoadingJob(true)
            await axios.post(`/Job/GetAllDraftJobs`, Data).then((resData) => {
                console.log('resData', resData);
                if (resData?.status === 204) {
                    setIsError(true)
                } else {
                    setDraftJob(resData.data.responseData)
                }
                setIsLoadingJob(false);
            });
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setIsError(true);
            } else {
                console.log(error);
            }
            setIsLoadingJob(false);
        }
    };


    //************************ Draft Job End  ************************//

    //************************ Draft Post Start  ************************//

    const [draftPost, setDraftPost] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const DraftPost = async () => {
        const Data = {
            "deviceType": "Web",
            "sessionId": sessionId,
            langKey: language === "en" ? "" : language,
        }
        try {
            setIsLoading(true);
            await axios.post(`/Posts/GetDraftPosts`, Data).then((resData) => {
                setIsLoading(false);
                console.log('GetDraftPosts', resData.data.responseData);
                const data = resData.data.responseData.reverse()
                setDraftPost(data)
            });
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setIsPostDraftError(true);
            } else {
                console.log(error);
            }
            console.log(error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        DraftPost();
        DraftJob()

    }, []);
    //************************ Draft Post End  ************************//

    // Helper function for regex escaping
    const escapeRegex = (str) => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    // Helper function to normalize dynamic values from API
    const normalizeDynamicValues = (dynamicValues = []) => {
        return (dynamicValues || []).map((dv, idx) => {
            if (!dv) return null;

            const {
                type,
                dVno,
                entity,
                entityID,
                entityId,
                userUid,
                displayName,
                display,
                entityName,
                hashTag,
            } = dv;

            const resolvedType = type || (hashTag ? "Hashtag" : "UserMention");
            const resolvedDisplayName = displayName ?? display ?? entityName ?? hashTag ?? "";

            let resolvedEntity = entity ?? entityID ?? entityId ?? userUid ?? hashTag ?? resolvedDisplayName;

            if (resolvedType === "Hashtag") {
                resolvedEntity = resolvedDisplayName;
            }

            return {
                type: resolvedType,
                dVno: dVno ?? idx + 1,
                entity: resolvedEntity,
                display: resolvedDisplayName,
                displayName: resolvedDisplayName,
            };
        }).filter(Boolean);
    };

    // Helper function to replace {n} placeholders with @mention/#hashtag
    const replaceDynamicValues = (content, dynamicValues = []) => {
        if (!content) return content;

        let result = content;
        const safeDynamicValues = Array.isArray(dynamicValues) ? dynamicValues : [];

        safeDynamicValues.forEach((item) => {
            const placeholder = `{${item.dVno}}`;
            const displayName = item.display ?? item.displayName ?? "";
            let replacement = "";

            if (item.type === "UserMention" || item.type === "CompanyMention") {
                replacement = `@${displayName}`;
            } else if (item.type === "Hashtag") {
                replacement = `#${displayName}`;
            } else {
                replacement = displayName;
            }

            result = result.replaceAll(placeholder, replacement);
        });

        return result;
    };

    // Convert mentions to clickable links (for display only)
    const convertMentionsToLinks = (content, dynamicValues) => {
        let modified = content;
        const ensureArray = (val) => (Array.isArray(val) ? val : []);

        ensureArray(dynamicValues).forEach(
            ({ type, displayName, display, entity }) => {
                const prefix =
                    type === "UserMention" || type === "CompanyMention"
                        ? "@"
                        : "#";

                const name = display || displayName;
                const fullText = `${prefix}${name}`;

                const link =
                    type === "UserMention" || type === "CompanyMention"
                        ? `/profile/${entity}`
                        : `/hashtag/${name}`;

                const regex = new RegExp(
                    escapeRegex(fullText) + "(?![^<]*>)",
                    "g"
                );

                modified = modified.replace(
                    regex,
                    `<a href="${link}" target="_blank" class="mention-link">${fullText}</a>`
                );
            }
        );

        return modified;
    };

    const addTargetBlankToAnchors = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;

        const anchors = div.querySelectorAll('a');
        anchors.forEach(anchor => {
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('rel', 'noopener noreferrer');
        });

        return div.innerHTML;
    };

    const linkifyContent = (htmlContent) => {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
        return htmlContent.replace(urlPattern, function (url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
    };

    // change page scroll top

    useEffect(() => {
        if (location.pathname === "/Draft") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location.pathname]);


    const renderTabContent = () => {
        switch (activeTab) {
            case 1:
                return (
                    <>
                        {isLoading ? (
                            <div className="draft-post-workspace mt-3">
                                <div className="row draft-post-grid">
                                    <div className="col-12 col-md-6 d-flex align-items-stretch mb-3 draft-post-col">
                                        <ShimmerDiv height={200} width="100%" />
                                    </div>
                                    <div className="col-12 col-md-6 d-flex align-items-stretch mb-3 draft-post-col">
                                        <ShimmerDiv height={200} width="100%" />
                                    </div>
                                </div>
                            </div>
                        )
                            : isPostDraftError || draftPost.length === 0 ? (
                                <div className="mt-2 error-image-cont error-connection">
                                    <img src={post.errorSmall} alt="404 Not Found" />
                                </div>
                            ) : (
                                <div className="draft-post-workspace">
                                <div className="row draft-post-grid">
                                {draftPost
                                    .filter((item) => !item.isDeleted)
                                    ?.map((item, index) => {
                                        const now = moment.utc().local();
                                        const itemTime = moment.utc(item?.postInfo?.creationTime).local();
                                        const diffSeconds = now.diff(itemTime, "seconds");
                                        const diffMinutes = now.diff(itemTime, "minutes");
                                        const diffHours = now.diff(itemTime, "hours");
                                        const diffDays = now.diff(itemTime, "days");

                                        const diffMonths = now.diff(itemTime, "months", true);
                                        const diffYears = now.diff(itemTime, "years", true);

                                        let result = "";

                                        /* JUST NOW */
                                        if (diffSeconds < 60) {
                                            result = t("Notifications.Just Now");
                                        }

                                        /* MINUTES */
                                        else if (diffMinutes < 60) {
                                            result =
                                                diffMinutes === 1
                                                    ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                                                    : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                                        }

                                        /* HOURS */
                                        else if (diffHours < 24) {
                                            result =
                                                diffHours === 1
                                                    ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                                                    : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                                        }

                                        /* DAYS */
                                        else if (diffDays < 30) {
                                            result =
                                                diffDays === 1
                                                    ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                                                    : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                                        }

                                        /* MONTHS */
                                        else if (diffMonths < 12) {
                                            const displayMonth =
                                                diffMonths >= 0.75 && diffMonths < 1.25
                                                    ? 1
                                                    : Math.round(diffMonths * 2) / 2;

                                            result =
                                                displayMonth === 1
                                                    ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                                                    : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                                        }

                                        /* YEARS */
                                        else {
                                            const displayYear =
                                                diffYears >= 0.75 && diffYears < 1.25
                                                    ? 1
                                                    : Math.round(diffYears * 2) / 2;

                                            result =
                                                displayYear === 1
                                                    ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                                                    : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                                        }


                                        console.log('draftPost', item);
                                        return (
                                            <div
                                                className="col-12 col-md-6 d-flex align-items-stretch mb-3 draft-post-col"
                                                key={item?.postInfo?.postId ?? index}
                                            >
                                            <div className="featured-card user-postOnlyContent draftPost p-2 w-100">
                                                <div className="feature-content p-2 d-flex justify-content-between">
                                                    <Link to={`/User/${item?.postInfo?.userUid}`}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="ImgAvatar">
                                                                <img src={item?.postInfo?.userAvatar} alt="" style={{ borderRadius: '50px' }} />
                                                            </div>
                                                            <div className="ms-2">
                                                                <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.userName}</h4>
                                                                {/* <p className="f-12">
                                                                    {moment
                                                                        .utc(item?.postInfo?.creationTime)
                                                                        .local()
                                                                        .format("DD MMMM YYYY [at] h:mm a")}
                                                                </p> */}
                                                                {language === "ar" ? (
                                                                    <Tooltip title={moment
                                                                        .utc(item?.postInfo?.creationTime)
                                                                        .locale(locale)
                                                                        .local()
                                                                        .format("D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                                        <p className="f-10 label">
                                                                            {moment
                                                                                .utc(item?.postInfo?.creationTime)
                                                                                .locale(locale)
                                                                                .local()
                                                                                .format("D MMMM YYYY [الساعة] h:mm a")}
                                                                        </p>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <Tooltip title={moment
                                                                        .utc(item?.postInfo?.creationTime)
                                                                        .local()
                                                                        .format(language === "en"
                                                                            ? "D MMMM YYYY [at] h:mm a"
                                                                            : "D MMMM YYYY [को] h:mm a")} arrow>
                                                                        <p className="f-10 label">
                                                                            {result}
                                                                            {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                                        </p>
                                                                    </Tooltip>


                                                                )}
                                                            </div>
                                                        </div>
                                                    </Link>
                                                    {/* <div className="d-flex align-items-center">
                                                        <div className="ImgAvatar">
                                                            <img src={NewsFeed.companyLogo} alt="" />
                                                        </div>
                                                        <div className="ms-2">
                                                            <h4 className="f-14 fw-bold mb-0">Ahmad Nur Fawaid</h4>
                                                            <p className="f-12">12 April at 09.29 PM</p>
                                                        </div>
                                                    </div> */}
                                                    <DraftInteraction
                                                        postId={item?.postInfo?.postId}
                                                        DraftPost={DraftPost}
                                                        setDraftJob={setDraftJob}
                                                        setDraftPost={setDraftPost}
                                                        postOriginId={item?.postInfo?.postOriginId}
                                                        postOriginType={item?.postInfo?.postOriginType}
                                                    // AllPostList={AllPostList}
                                                    // postList={postList}
                                                    // setPage={setPage}
                                                    // setPostList={setPostList}
                                                    // page={page}
                                                    // setTotalPages={setTotalPages}
                                                    // totalPages={totalPages}
                                                    />
                                                </div>
                                                {/* <p className="f-14 p-2">{item?.postInfo?.postContent}</p> */}
                                                {item?.postInfo?.postContent && (
                                                    <div className="f-14 p-2 postContent">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: (() => {
                                                                    const normalized = normalizeDynamicValues(item?.postInfo?.dynamicValues || []);
                                                                    const replaced = replaceDynamicValues(item?.postInfo?.postContent || "", normalized);
                                                                    const withLinks = convertMentionsToLinks(replaced, normalized);
                                                                    return linkifyContent(addTargetBlankToAnchors(withLinks));
                                                                })()
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                {/* <PostComponent item={item} /> */}

                                                <div className="feed-post p-2">
                                                    {/* <div className="row">
                                                        {item.mediaFilesList.slice(0, 4).map((file, idx) => (
                                                            <div
                                                                key={idx}
                                                                className={`col-${item.postMediaCount === 1 ? "12" : "6"
                                                                    } ${item.postMediaCount === 3 && idx === 0
                                                                        ? "col-12"
                                                                        : ""
                                                                    }`}
                                                                style={{
                                                                    position: "relative",
                                                                    padding:
                                                                        item.postMediaCount === 3 && idx === 0
                                                                            ? "0 0 5px 0"
                                                                            : item.postMediaCount === 3 && idx === 1
                                                                                ? "0 5px 5px 0"
                                                                                : item.postMediaCount === 4 && idx === 2
                                                                                    ? "0 5px 0 0"
                                                                                    : item.postMediaCount === 4 && idx === 0
                                                                                        ? "0 5px 5px 0"
                                                                                        : item.postMediaCount === 2 && idx === 0
                                                                                            ? "0 5px 5px 0"
                                                                                            : "",
                                                                }}
                                                            >
                                                                <img
                                                                    src={file.mediaName}
                                                                    alt=""
                                                                    className="img-fluid"
                                                                    width={"100%"}
                                                                />
                                                                {idx === 3 && item.postMediaCount > 4 && (
                                                                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                                        +{item.postMediaCount - 4}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div> */}
                                                    {console.log("mediaFilesList", item?.postInfo)}
                                                    <div className="row">
                                                        {item?.postInfo?.mediaFilesList?.slice(0, Math.min(item?.postInfo?.postMediaCount, 4)).map((file, idx) => (

                                                            <div
                                                                key={idx}
                                                                className={`col-${item?.postInfo?.postMediaCount === 1 ? "12" : "6"} 
                                                               ${item?.postInfo?.postMediaCount === 3 && idx === 0 ? "col-12" : ""}`}
                                                                style={{
                                                                    position: "relative",
                                                                    padding:
                                                                        item?.postInfo?.postMediaCount === 3 && idx === 0
                                                                            ? "0 0 5px 0"
                                                                            : item?.postInfo?.postMediaCount === 3 && idx === 1
                                                                                ? "0 5px 5px 0"
                                                                                : item?.postInfo?.postMediaCount === 4 && idx === 2
                                                                                    ? "0 5px 0 0"
                                                                                    : item?.postInfo?.postMediaCount === 4 && idx === 0
                                                                                        ? "0 5px 5px 0"
                                                                                        : item?.postInfo?.postMediaCount === 2 && idx === 0
                                                                                            ? "0 5px 5px 0"
                                                                                            : "",
                                                                }}
                                                            >
                                                                {console.log("mediaFilesList", item?.postMediaCount)}

                                                                <ImageWithLoader
                                                                    src={file.mediaName}
                                                                    alt=""
                                                                    className="img-fluid"
                                                                    width={"100%"}
                                                                />

                                                                {idx === 3 && item.postInfo?.postMediaCount > 4 && (
                                                                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                                        +{item?.postInfo?.postMediaCount - 4}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>


                                                </div>
                                                {/* <div className="postengagement">
                                                <PostEngagement
                                                    item={item}
                                                    postId={item?.postId}
                                                // AllPostList={AllPostList}
                                                // postList={postList}
                                                // setPage={setPage}
                                                // setPostList={setPostList}
                                                // page={page}
                                                // setTotalPages={setTotalPages}
                                                // totalPages={totalPages}

                                                />
                                            </div> */}

                                            </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                </div>
                            )}
                    </>
                );
            case 2:
                return (
                    <div className="job-search-workspace draft-job-workspace">
                        {isLoadingJob ? (
                            <div className="row job-list-grid">
                                <div className="col-12 col-md-6 d-flex align-items-stretch mt-3 IncreaseWidthJobCard">
                                    <ShimmerDiv height={250} width="100%" rounded={4} />
                                </div>
                                <div className="col-12 col-md-6 d-flex align-items-stretch mt-3 IncreaseWidthJobCard">
                                    <ShimmerDiv height={250} width="100%" rounded={4} />
                                </div>
                            </div>
                        ) : isError || draftJob?.length === 0 ? (
                            <div className="mt-2 error-image-cont error-connection">
                                <img src={post.errorSmall} alt="404 Not Found" />
                            </div>
                        ) : (
                            <div className="row job-list-grid">
                                {(draftJob || [])
                                    .filter((item) => !item.isDeleted)
                                    .map((item) => (
                                        <PortalJobCard
                                            key={item.jobId}
                                            item={item}
                                            hideBookmark
                                            wrapperClassName="col-12 col-md-6 d-flex align-items-stretch mt-3 IncreaseWidthJobCard"
                                            menu={
                                                <JobDraftInteraction
                                                    DraftJob={DraftJob}
                                                    jobId={item?.jobId}
                                                    item={item}
                                                />
                                            }
                                            footer={
                                                <div className="jobAction d-flex justify-content-between align-items-center">
                                                    <Link to={`/JobDetail/${item.jobId}`}>
                                                        <button className="mainBtn4">
                                                            <VisibilityOutlinedIcon />
                                                            {t("Manage Job.View")}
                                                        </button>
                                                    </Link>
                                                </div>
                                            }
                                        />
                                    ))}
                            </div>
                        )}
                    </div>
                );
            default:
                return null;
        }
    };

    useEffect(() => {
        setActiveTab(getDraftTabIndex(tab));
    }, [tab]);


    // -------------------------------------------------------------------------
    const { setIsNewsPageLoaded } = useNewsFeedStore();

    useEffect(() => {
        setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

        return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
    }, [setIsNewsPageLoaded]);

    // -------------------------------------------------------------------------

    return (
        <>
            
      <div className="connectionPage-ad">
        <Row>
          <Col md={12}>
            <div
              className="Adwrapper"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '150px',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  display: 'block',
                  width: '100%',
                  height: '150px',
                }}
              >
                <GoogleAdUnit
                  adSlot="5695666532"
                  layoutKey="-6t+ed+2i-1n-4w"
                  fullWidthResponsive={false}
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '150px',
                    textAlign: 'center',
                    margin: '0 auto',
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
			<div>
                <div className="friendsHeaderText p-2 pt-0 pb-0">
                    <h1>{t("Sidemenubar.Drafts")} </h1>
                    <p className="discovery-subtitle mb-0">
                        {t("Drafts.DiscoverSubtitle", {
                            defaultValue: "Finish saved posts and jobs when you are ready to publish.",
                        })}
                    </p>
                </div>
                <div className="tabButton d-flex p-2 w-100 connectionTab wlj-tab-bar">
                    <NavLink
                        //onClick={() => setActiveTab(1)}
                        onClick={() => goToDraftTab(1)}
                        className={`text-center ${activeTab === 1 ? "activeTab" : ""}`}
                    >
                        <ArticleOutlinedIcon />
                        <p className="f-14 tabName">{t("Drafts.Post Drafts")}</p>
                    </NavLink>
                    <NavLink
                        // onClick={() => setActiveTab(2)}
                        onClick={() => goToDraftTab(2)}
                        className={`text-center ${activeTab === 2 ? "activeTab" : ""}`}
                    >
                        <WorkOutlineSharpIcon />
                        <p className="f-14 tabName">{t("Drafts.Job Drafts")} </p>
                    </NavLink>
                </div>

                <div className="resume-section">{renderTabContent()}</div>
            </div>
        </>
    )
}

export default Draft